<template>
        <div 
            class="bg-progress-bar" 
            :class="backgroundColor"
            :style="{ width: width + 'rem'}"
        >
            <div class="progress-bar" :class="progressColor" :style="progressBarStyle"></div>
        </div>
</template>

<script>

export default {
	name: 'b-progress-bar',
	components: {
		
    },
    computed: {
        backgroundColor() {
            return `bg-${this.color}-lighter-3`;
        },
        progressColor() {
            return `bg-${this.color}-base`;
        },
        progressBarStyle() {
            let progressBar = `width: ${(this.completedSteps * 100) / this.steps}%;`;
            if (this.steps === this.completedSteps) 
                return `${progressBar}; border-radius: 10px;`;
            return `${progressBar}; border-radius: 10px 0px 0px 10px;`;
        }
    },
	props: {
        /**
         * A cor que será utilizada na progressBar
         */
		color: {
            type: String,
            default: 'blue'
        },
        /**
         * Quantidade de steps que o progressBar terá 
        */
		steps: {
            type: Number,
            default: 10
        },
        /**
         * Quantidade de steps que já completos
        */
        completedSteps: {
            type: Number,
            default: 5
        },
        /**
         * Tamanho da barra de progresso
        */
        width: {
            type: String,
            default: '25.6'
        }
	}
};
</script>

<style scoped lang="scss">
.bg-progress-bar {
    border-radius: 10px;
    height: 0.8rem;
}
.progress-bar {
    height: 0.8rem;
}
</style>

<docs>
    ProgressBar

    ```js
    <b-progress-bar color="pink" steps="10" completedSteps="9" />
    ```
</docs>
